<h1 mat-dialog-title>Noodnummers ({{ numbersCount() }})</h1>

<mat-dialog-content>
  @if (!isOnlyRidePlanner()) {
    <div class="info-note">
      <mat-icon>warning</mat-icon>
      <span>Let op: wijzigingen worden pas definitief opgeslagen als je de passagier opslaat.</span>
    </div>
  }

  <form [formGroup]="phoneForm">
    <div formArrayName="numbers" class="numbers-list">
      @for (group of numbers.controls; track group; let i = $index) {
        <div [formGroupName]="i" class="number-row">
          <h3>Noodnummer {{ i + 1 }}</h3>
          <div class="fields-grid">
            <mat-form-field>
              <mat-label>Naam</mat-label>
              <input matInput formControlName="name" />
              @if (!isOnlyRidePlanner() && group.get('name')?.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>

            <mat-form-field>
              <mat-label>Telefoonnummer</mat-label>
              <input matInput formControlName="phoneNumber" />
              @if (!isOnlyRidePlanner() && group.get('phoneNumber')?.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
              @if (!isOnlyRidePlanner() && group.get('phoneNumber')?.hasError('phoneValidator')) {
                <mat-error>Telefoonnummer is ongeldig.</mat-error>
              }
            </mat-form-field>

            <mat-form-field>
              <mat-label>Relatie</mat-label>
              <input matInput formControlName="description" />
              @if (!isOnlyRidePlanner() && group.get('description')?.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>

            @if (!isOnlyRidePlanner()) {
              <div class="delete-button-wrapper">
                <button
                  mat-icon-button
                  aria-label="Telefoonnummer verwijderen"
                  (click)="removeNumber(i)"
                  type="button"
                  matTooltip="Verwijderen"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            }
          </div>
        </div>
      }

      @if (numbersCount() === 0) {
        <div class="empty-state">
          <p>Nog geen noodnummers toegevoegd.</p>
        </div>
      }
    </div>

    @if (!isOnlyRidePlanner()) {
      <div class="actions-row">
        <button mat-flat-button class="secondary-color" (click)="addNumber()" type="button">
          <mat-icon>add</mat-icon>
          Noodnummer toevoegen
        </button>
      </div>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (!isOnlyRidePlanner()) {
    <button mat-button mat-dialog-close>Annuleren</button>
    <button mat-flat-button class="primary-color" [disabled]="phoneForm.invalid" (click)="confirm()">Bijwerken</button>
  } @else {
    <button mat-flat-button class="primary-color" mat-dialog-close>Sluiten</button>
  }
</mat-dialog-actions>
